export default __webpack_public_path__ + "static/media/129-ossetia.9b09a8ce.svg";